import moment from 'moment';

export function purchaseDateCell(value, style) {
  const date = value ? (typeof value === 'string' ? moment(value, moment.ISO_8601, true) : moment(value)) : null;
  if (!date?.isValid()) return { v: '', s: style };
  const serial = (Date.UTC(date.year(), date.month(), date.date()) - Date.UTC(1899, 11, 30)) / 86400000;
  return { v: serial, t: 'n', z: 'dd/mm/yyyy', s: style };
}

export function purchaseNumberCell(value, style) {
  const number = value === null || value === undefined || value === '' ? NaN : Number(value);
  return Number.isFinite(number)
    ? { v: Number(number.toFixed(2)), t: 'n', z: '#,##0.00', s: style }
    : { v: '', s: style };
}
